<template>
  <div>
    <a-radio-group
      :default-value="5"
      @change="(e)=>$emit('change',e)"
    >
      <a-radio :value="5">
        通过
      </a-radio>
      <a-radio :value="4">
        不通过
      </a-radio>
    </a-radio-group>
    <div
      v-show="isShow"
      style="margin-top:10px"
    >
      <a-input
        type="text"
        @change="(value)=>$emit('changeInput',value)"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: ['isShow'],
  data(){
    return{
    };
  },
  methods: {
  },
};
</script>

<style>

</style>